import { IonButton } from '@ionic/react';
import {
  MeasureForm,
  MeasureFormValues,
} from '@lidea/analysis/desktop/shared/ui';
import { ModalPage } from '@lidea/shared/ui/layout';
import { Measure } from '@lidea/shared/util/types';
import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './measure-modal.module.css';

const MEASURE_FORM_ID = 'measure-form';

interface MeasureModalProps {
  analysisId: string;
  plotId: string;
  measure: Measure;
  zone: number;
  onSubmit: (data: MeasureFormValues) => void;
  pending?: boolean;
  dismiss: () => void;
}

const MeasureModal: React.FC<MeasureModalProps> = (props) => {
  const { t } = useTranslation(['common', 'plot', 'analysis'], {
    useSuspense: false,
  });

  const handleSubmitClick = () => {
    document.getElementById(MEASURE_FORM_ID)?.requestSubmit();
  };

  return (
    <ModalPage
      centerTitle
      hideCloseButton
      keyboardFriendly
      title={`Point ${props.zone}`}
      toolbarEnd={
        <IonButton
          color="success"
          disabled={props.pending}
          onClick={handleSubmitClick}
        >
          {t('common:validate')}
          {props.pending ? <Loader color="white" ml="sm" size="xs" /> : null}
        </IonButton>
      }
      toolbarStart={
        <IonButton
          color="danger"
          disabled={props.pending}
          fill="clear"
          onClick={props.dismiss}
        >
          {t('common:cancel')}
        </IonButton>
      }
      onClose={props.dismiss}
    >
      {props.measure ? (
        <div className={styles['formHost']}>
          <MeasureForm
            analysisId={props.analysisId}
            fields={{
              static: props.measure.static,
              dynamic: props.measure.dynamic,
            }}
            formId={MEASURE_FORM_ID}
            formLayout="scrollParent"
            externalScroll
            hideActions
            i18n={{
              submit: t('common:validate'),
              cancel: t('common:cancel'),
            }}
            measureId={props.measure.id}
            measureZone={props.measure.point.properties.zone}
            pending={props.pending}
            plotId={props.plotId}
            useIonicActions
            onCancel={props.dismiss}
            onSubmit={props.onSubmit}
          />
        </div>
      ) : null}
    </ModalPage>
  );
};

export default MeasureModal;
